(function() {

  var simpleMenu = document.querySelector('.simple-ajax-menu');
  var simpleContainer = document.querySelector('.simple-ajax-container');

  if( !simpleMenu ) return;

  var simpleMenuControler = new SimpleMenuControler();
  simpleMenuControler.register_section_menu( simpleMenu );
  simpleMenuControler.register_section_container( simpleContainer );

})();